import { render } from "./metrics-result.vue?vue&type=template&id=15cc7328&scoped=true"
import script from "./metrics-result.vue?vue&type=script&lang=js"
export * from "./metrics-result.vue?vue&type=script&lang=js"

import "./metrics-result.vue?vue&type=style&index=0&id=15cc7328&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15cc7328"]])

export default __exports__